import { useLingui } from '@lingui/react/macro';
import { Section } from './section';
import { SpacedElements } from './spaced-elements';
import { Title } from './title';

export function TotalAmountBlock({
  amount,
  color
}: {
  amount: string;
  color: string;
}) {
  const { t } = useLingui();

  return (
    <Section $color={color} $classModifier="total-amount" $withBottomDivider>
      <SpacedElements>
        <Title classModifier="label">{t`Total`}</Title>
        <Title classModifier="amount">{amount}</Title>
      </SpacedElements>
    </Section>
  );
}
